import React from 'react'
import { Input } from 'reactstrap'
import PropTypes from 'prop-types'

Filters.propTypes = {
  columns: PropTypes.array.isRequired,
  filter: PropTypes.array.isRequired,
  id: PropTypes.string.isRequired,
  resolveClassName: PropTypes.func.isRequired,
}

export default function Filters(props) {
  return (
    <tr>
      {props.columns.map((column, colIndex) => {
        const resolvedClassName = props.resolveClassName(
          column.headerClassName,
          column,
        )
        // we don't allow filtering if the field value is a function without a filter value because
        // we don't want to try and filter on JSX
        if (
          column.filter === false ||
          (typeof column.fieldValue === 'function' && !column.filterValue)
        )
          return <th key={`${props.id}_f_${colIndex}`}>&nbsp;</th>

        const colFilter = props.filter.find(
          filter => filter.columnTitle === column.title,
        ) || { query: '' }
        return (
          <th className={resolvedClassName} key={`${props.id}_f_${colIndex}`}>
            <div>
              <Input
                onChange={e => props.updateFilter(column.title, e.target.value)}
                type="text"
                value={colFilter.query}
              />
              <i className="fas fa-filter" />
            </div>
            <style jsx>
              {`
                th {
                  padding-top: 0;
                }
                div {
                  position: relative;
                }
                .fa-filter {
                  position: absolute;
                  top: 0.6rem;
                  right: 0.5rem;
                  font-size: 1.25rem;
                  color: ${colFilter.query.length > 0 ? '#5d9f00' : '#dee2e6'};
                }
              `}
            </style>
          </th>
        )
      })}
    </tr>
  )
}



// WEBPACK FOOTER //
// ./src/components/AutoTable/Filters.js